import { Box, Container, Typography } from "@mui/material";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import { TailSpin } from "react-loader-spinner";
import Layout from "../../component/Layout";
import useArticle from "../../features/guides/hooks/useArticle";
import { Spinner } from "../../styles/Course.module";

const GuideView = ({ data }) => {
  const router = useRouter();
  const { src } = router.query;
  const [userArticle, isLoading] = useArticle(src);

  const loadSpinner = () => {
    return (
      <Spinner>
        <TailSpin />
      </Spinner>
    );
  };

  const displayArticle = (
    <Box mt={4} mb={8}>
      <div
        className="guide-container"
        dangerouslySetInnerHTML={{ __html: userArticle }}
      />
    </Box>
  );
  return (
    <Layout>
      <Container>
        <Head>
          <title>{data.title}</title>
          <meta name="description" content={data.description} />
          <meta property="og:title" content={data.title} />
          <meta property="og:description" content={data.description} />
          <meta property="og:image" content={data.image} />
          <meta property="og:type" content="guide" />
        </Head>
        <>
          <Link href="/guide/list" className="nextLink">
            <Typography
              display="flex"
              justifyContent="flex-end"
              component="subtitle"
              sx={{
                color: "guideLink.primary",
                maxWidth: "90%",
              }}
            >
              Back To Guide List
            </Typography>
          </Link>

          <Typography component="span">
            {isLoading ? loadSpinner() : displayArticle}
          </Typography>
        </>
      </Container>
    </Layout>
  );
};

export async function getServerSideProps(context) {
  const { id } = context.query;

  if (!id) {
    return {
      notFound: true, // Handle missing ID case
    };
  }

  // Fetch data based on the ID (replace this with your actual fetch logic)
  const fetchData = async (id) => {
    try {
      const apiUrl =
        process.env.NEXT_APP_ENVIRONMENT === "Production"
          ? "https://d2ujlimzmmtnnb.cloudfront.net/guide-api/guide/list"
          : "https://wd0ym6lzgh.execute-api.ap-south-1.amazonaws.com/Stage/guide-api/guide/list";
      const response = await fetch(`${apiUrl}?guide_id=${id}`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to fetch data:", error);
      return null;
    }
  };

  const data = await fetchData(id);

  if (!data) {
    return {
      notFound: true, // Handle case where ID does not match any data
    };
  }

  return {
    props: {
      data: data[0],
    },
  };
}

export default GuideView;
